import { Autocomplete, TextField } from "@mui/material";
import type { ProductOption } from "../measurementTypes";

export default function ProductPicker({
  value,
  products,
  onChange,
}: {
  value: string | null;
  products: ProductOption[];
  onChange: (productId: string | null) => void;
}) {
  const selected = products.find((product) => product.id === value) ?? null;
  return (
    <Autocomplete
      size="small"
      fullWidth
      options={products}
      value={selected}
      groupBy={(product) => product.organizationProductType?.name ?? "Uncategorized"}
      getOptionLabel={(product) => product.name ?? "Untitled product"}
      isOptionEqualToValue={(option, current) => option.id === current.id}
      onChange={(_, product) => onChange(product?.id ?? null)}
      renderInput={(params) => <TextField {...params} placeholder="Select product…" />}
      componentsProps={{ popper: { style: { zIndex: 1600 } } }}
    />
  );
}
